import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { postAmend } from 'src/api/amendService';
import { ProcessAmendDto } from 'src/api/amendService/dto/ProcessAmend.dto';

export const usePostAmend = () =>
    useMutation<void, AxiosError, ProcessAmendDto>({
        mutationKey: ['process-amend'],
        mutationFn: (payload) => postAmend(payload),
    });
